<template>
  <div>
      <!--Header Components-->
      <base-header class="pb-6" type="">
        <b-row class="align-items-center py-4">
          <b-col lg="12" cols="12">
            <!-- <h6 class="h2 text-white d-inline-block mb-0">{{$route.name}}</h6> -->
            <h6 class="h2 d-inline-block mb-0">{{language_terms[$route.name]}}</h6>
            <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
              <route-breadcrumb/>
            </nav>
          </b-col>

        </b-row>
      </base-header>
      <b-container fluid class="mt--6">
        <div>
            <loading :active.sync="loading" 
              color= '#007bff'
              :width= '128'
              :height= '128'
              loader='dots'
              :can-cancel="true" 
              :is-full-page="fullPage">
            </loading>
        </div>
        <b-row>
          <b-col lg="12">
            <div class="card-wrapper">
              <card>
                <div slot="header" class="mb-0">
                  <b-row>
                    <b-col cols="8">
                        <h3>{{language_terms['QUICK_SEARCH']}}</h3>
                    </b-col>
                    <b-col cols="4">
                       <base-button type="success" @click="newPurchaseDocument" class="float-right">
                          <i class="fa fa-plus"></i>
                          <!-- {{language_terms['NEW']}} Purchase  -->
                          <!-- {{type == 'PO' ? language_terms['ORDER'] : type == 'PI' ? language_terms['INVOICE']: language_terms['GRN']}} -->
                        </base-button>
                        <base-button type="primary" @click="newInvoiceFromGRN" class="float-right mr-4" v-if="type == 'PI' && 0">
                          <i class="fa fa-plus"></i>
                          From GRN <!--{{language_terms['INVOICE_FROM_GRN']}}-->
                        </base-button>
                    </b-col>
                  </b-row>
                </div>
                <b-row>
                  <b-col md="3" >
                    <base-input :label="language_terms['VENDOR']" v-model="filter.keyword" v-on:keyup.enter="clickOnSearch"></base-input>
                  </b-col>
                  <b-col :md="type == 'GRN' ? 4 : 3" >
                    <base-input :label="language_terms['PRODUCT']" v-model="filter.product" v-on:keyup.enter="clickOnSearch"></base-input>
                  </b-col>
                  <b-col md="2" >
                    <base-input :label="language_terms['DATE_FROM']">
                      <flat-picker slot-scope="{focus, blur}"
                                  @on-open="focus"
                                  @on-close="blur"
                                  style="background-color: white;"
                                  class="form-control datepicker"
                                  v-model="filter.date_from">
                      </flat-picker>
                    </base-input>
                  </b-col>
                  <b-col md="2">
                    <base-input :label="language_terms['DATE_TO']">
                      <flat-picker slot-scope="{focus, blur}"
                                  @on-open="focus"
                                  @on-close="blur"
                                  style="background-color: white;"
                                  class="form-control datepicker"
                                  v-model="filter.date_to">
                      </flat-picker>
                    </base-input>
                  </b-col>
                  <b-col md="1" v-if="type != 'GRN'">
                    <base-input :label="language_terms['STATUS']">
                      <el-select v-model="filter.status" filterable>
                        <el-option v-for="option in status_options"
                                  :key="option.value"
                                  :label="option.label"
                                  :value="option.value">
                        </el-option>
                      </el-select>
                    </base-input>
                  </b-col>
                  <b-col cols="1" class="mt-4">
                    <base-button type="primary" @click="clickOnSearch" class="mt-2"><i class="fa fa-search"></i></base-button>
                  </b-col>
                </b-row>
              </card>
              <!-- Search Results -->
              <PaginatedTables :myColumns="tableColumns" :tableData="items" :cardTitle="language_terms['SEARCH_RESULTS']" v-if="items.length > 0"/>
            </div>
          </b-col>
        </b-row>
      </b-container>
  </div>
</template>
<script>
import { Select, Option } from 'element-ui'
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';  
import { mapState } from "vuex";
import PaginatedTables from '@/views/Tables/PaginatedTables'

export default {
  props:
  {
        type: {
          type: String,
          default: 'PO',
          description: 'Purchase Type',
          required:true
        },
        addNew: {
          type: String,
          default: 'Add New Purchase Document',
          description: 'Add New Purchase Document',
          required:true
        },
  },
  components:{
    Loading,
    [Select.name]: Select,
    [Option.name]: Option,
    flatPicker,
    PaginatedTables
  },
  computed:{
      ...mapState({
        purchase_filter:state => state.purchase.filter,
        purchase_orders: state => state.purchase.purchase_orders,
        purchase_invoices: state => state.purchase.purchase_invoices,
        grns: state => state.grns.grns,
        language_terms: state => state.languages.language_terms,
        selected_lang: state => state.languages.selected_langauge,
      }),
    },
  watch:{
     language_terms: {
          handler(val){
              this.updateTableLang()
          }
        },
    purchase_invoices: {
      // This will let Vue know to look inside the array
      deep: true,
      handler(){
        this.items = this.purchase_invoices
      }
    },
    purchase_orders: {
      // This will let Vue know to look inside the array
      deep: true,
      handler(){
        this.items = this.purchase_orders
      }
    },
    grns: {
      // This will let Vue know to look inside the array
      deep: true,
      handler(){
        this.items = this.grns
      }
    }
  },
  async mounted()
  {
      if(this.type == 'PO')
      {
          this.filter.limit = 20
          this.filter.type = this.type          
          await this.$store.dispatch("purchase/quickSearch", this.filter);
          this.items = this.purchase_orders
      }
      else if(this.type == 'PI')
      {
        this.filter.limit = 20
        this.filter.type = this.type
        await this.$store.dispatch("purchase/quickSearch", this.filter);
        this.items = this.purchase_invoices
      }
      else if(this.type == 'PI')
      {
        this.items = this.grns
      }
      this.updateTableLang()

      if(this.purchase_filter)
      {
        this.filter = this.purchase_filter
      }
  },
  data(){
    return{
      fullPage:true,
      loading:false,
      filter:{
        keyword:"",
        date_from:null,
        date_to:null,
        type:null,
        status:'ALL'
      },
      items:[],
      tableColumns: [
            // {
            //   prop: 'code',
            //   label: 'DOCUMENT',
            //   // minWidth: 80,
            //   sortable: true,
            //   key:'CODE',
            //   isVisible:false,
            // },
            {
               prop: 'code_revision',
               label: 'Document#',
               // minWidth: 80,
               sortable: true,
               key:'DOCUMENT'
            },            
            {
              prop: 'contact_name',
              label: 'VENDOR',
              minWidth: 180,
              sortable: true,
              key:'VENDOR'

            },
            {
              prop: 'date',
              label: 'Date',
              minWidth: 60,
              sortable: true,
              key:'DATE'

            },
            {
              prop: 'reference',
              label: 'Reference',
              sortable: true,
              key:'REFERENCE'

            },
            {
              prop: 'currency_code',
              label: 'Currency',
              sortable: true,
              minWidth: 70,
              key:'CURRENCY'
            },            
            {
              prop: 'nett_amount_formatted',
              label: 'Amount',
              sortable: true,
              key:'AMOUNT'
            },
            {
              prop: 'remarks_internal',
              label: 'Remarks (Internal)',
              sortable: true,
              key:'REMARKS'
            },            
            {
              prop: 'requestor_user_name',
              label: 'Requestor',
              sortable: true,
              key:'REQUESTOR'
            },
            
            // {
            //   prop: 'status',
            //   label: 'Status',
            //   minWidth: 120,
            //   sortable: true,
            //   key:'STATUS'
            // },            
        ],
      status_options:[
        {
          label:"All",
          value:"ALL"
        },
        {
          label:"Pending",
          value:"PENDING"
        },
        {
          label:"Packing",
          value:"PACKING"
        },
        {
          label:"Delivery In Transit (Partial)",
          value:"DELIVERY_IN_TRANSIT_PARTIAL"
        },
        {
          label:"Delivery In Transit",
          value:"DELIVERY_IN_TRANSIT"
        },
        {
          label:"Delivered (Partial)",
          value:"DELIVERED_PARTIAL"
        },
        {
          label:"Delivered",
          value:"DELIVERED"
        },
        {
          label:"Fulfilled",
          value:"FULFILLED"
        },
        {
          label:"Cancelled",
          value:"CANCELLED"
        },
        {
          label:"Approved",
          value:"APPROVED"
        },
        {
          label:"Rejected",
          value:"REJECTED"
        },
      ],
      sales_types:[
        {
          label:"Quotation",
          value:"SQ"
        },
        {
          label:"Order",
          value:"SO"
        },
        {
          label:"Invoice",
          value:"SI"
        }
      ]

    }
  },

  methods:{
    newInvoiceFromGRN()
    {
       this.$router.push("/purchase/purchase-invoice-from-grn/_new")
    },
     updateTableLang(){
      for(let i=0; i < this.tableColumns.length;i++)
      {
         let key = this.tableColumns[i].key
         this.tableColumns[i].label = this.language_terms[key]
      }
    },
    async clickOnSearch(){
      this.filter.type = this.type
      this.loading = true
      if(this.type == 'GRN')
        await this.$store.dispatch("grns/quickSearch", this.filter);
      else
        await this.$store.dispatch("purchase/quickSearch", this.filter);

      for (let x = 0; x < this.items.length; x++)
      {
        this.items[x]['gross_amount'] = (this.items[x]['gross_amount'] * 1).toLocaleString('en-US', {minimumFractionDigits:2, maximumFractionDigits:2})
      }
      this.loading = false
    },
    clickOnReset(){
      this.filter = {
          keyword:"",
          date_from:null,
          date_to:null,
          type:'PO',
          status:'ALL'
      }
    },
    async newPurchaseDocument(){
       this.$router.push(this.$props.addNew + "_new")
    }
  }
}
</script>
